import { motion } from "framer-motion";

const VARIANT_ACCENTS = { kl: "#00E676", dr: "#2997FF", golden_raja: "#FFD700" };

const SCHEDULE = [
  { time: "11:00 AM", name: "Golden Raja 11AM", variant: "golden_raja" },
  { time: "12:00 PM", name: "Golden Raja 12PM", variant: "golden_raja" },
  { time: "01:00 PM", name: "Dear 1PM", variant: "dr" },
  { time: "03:00 PM", name: "KL 3PM", variant: "kl" },
  { time: "05:00 PM", name: "Golden Raja 5PM", variant: "golden_raja" },
  { time: "06:00 PM", name: "Dear 6PM", variant: "dr" },
  { time: "07:00 PM", name: "Golden Raja 7PM", variant: "golden_raja" },
  { time: "08:00 PM", name: "Dear 8PM", variant: "dr" },
];

export default function Timetable() {
  return (
    <section data-testid="timetable-section" className="px-6 py-32 md:px-16 lg:px-24">
      <div className="mx-auto max-w-[1400px]">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
          className="mb-16"
        >
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-[#666666]">Daily rhythm</p>
          <h2 className="font-heading text-4xl font-black uppercase tracking-tighter md:text-6xl">
            Draw <span className="text-[#FFD700]">timetable</span>
          </h2>
        </motion.div>

        <div className="border-t border-white/10">
          {SCHEDULE.map((row, i) => (
            <motion.div
              key={row.time + row.name}
              data-testid={`timetable-row-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.06, ease: [0.76, 0, 0.24, 1] }}
              className="group grid grid-cols-12 items-center gap-4 border-b border-white/10 py-6 transition-colors duration-300 hover:bg-white/[0.03] md:py-8"
            >
              <div className="col-span-5 md:col-span-4">
                <span className="font-editorial text-3xl italic leading-none text-white/80 transition-colors duration-300 group-hover:text-white md:text-5xl">
                  {row.time}
                </span>
              </div>
              <div className="col-span-6 md:col-span-7">
                <p className="font-heading text-sm font-bold uppercase tracking-[0.1em] md:text-xl">{row.name}</p>
              </div>
              <div className="col-span-1 flex justify-end">
                <span
                  className="inline-block h-2.5 w-2.5 rounded-full transition-transform duration-300 group-hover:scale-150"
                  style={{ backgroundColor: VARIANT_ACCENTS[row.variant] }}
                />
              </div>
            </motion.div>
          ))}
        </div>
        <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.25em] text-[#666666]">
          Charts drop shortly after each draw — refresh the vault
        </p>
      </div>
    </section>
  );
}
